// Lightweight i18n for RutaForge (ES / EN).
// - Persists the chosen language in localStorage ("rutaforge.lang").
// - Auto-detects: Spanish for Spanish-speaking locales, English otherwise.
// - Exposes a plain t() usable outside React (default names, exports, toasts).

const STORAGE_KEY = "rutaforge.lang";

export const translations = {
    es: {
        // Toolbar
        expandTools: "Desplegar herramientas",
        minimizeTools: "Minimizar herramientas",
        trackNamePlaceholder: "Nombre de la ruta…",
        modeTrack: "Track",
        modePoi: "POI",
        modeView: "Ver",
        modeTrackTitle: "Añadir puntos al track",
        modePoiTitle: "Añadir punto de interés",
        modeViewTitle: "Solo visualizar",
        undo: "Deshacer",
        undoTitle: "Deshacer último punto",
        elevation: "Altitudes",
        elevationTitle: "Obtener altitudes (Open-Elevation)",
        surface: "Superficie",
        surfaceTitle: "Analizar asfalto/pista de la ruta (OSM)",
        autoTrace: "Auto-trazar",
        autoTraceTitle: "Trazar por carreteras o senderos",
        offroad: "Offroad",
        offroadDesc: "Trazar por caminos y pistas sin asfaltar aptos para vehículo",
        trackDifficulty: "Dificultad de la pista",
        grade1: "Grado 1",
        grade1desc: "Grava / turismo",
        grade2: "Grado 2",
        grade2desc: "Pista media",
        grade3: "Grado 3",
        grade3desc: "4x4 / difícil",
        grade1hint: "Pistas anchas de grava, aptas para turismo",
        grade2hint: "Pistas y caminos de tierra medios",
        grade3hint: "Terreno exigente para 4x4 / todoterreno",
        brouterLabel: "Pistas sin asfaltar (BRouter)",
        osrmLabel: "Snap a vías reales (OSRM)",
        carMoto: "Coche / moto",
        bike: "Bicicleta",
        onFoot: "A pie",
        share: "Compartir",
        shareBtnTitle: "Generar enlace para compartir",
        importExport: "Importar / Exportar",
        importLabel: "Importar",
        importFile: "Archivo GPX / KML / GeoJSON",
        exportLabel: "Exportar",
        library: "Biblioteca",
        savedRoutes: "Rutas guardadas",
        noSavedRoutes: "Aún no hay rutas guardadas.",
        showOtherRoutes: "Mostrar otras rutas",
        pts: "pts",
        save: "Guardar",
        newRoute: "Nueva",
        newRouteTitle: "Nueva ruta vacía",
        clearTitle: "Limpiar todos los puntos",
        language: "Idioma",
        zoomIn: "Acercar",
        zoomOut: "Alejar",
        layers: "Capas",
        trackPointsToggle: "Puntos del track",

        // StatsBar
        distance: "Distancia →",
        roundtrip: "Ida y vuelta ⇄",
        altMax: "Alt. máx ▲",
        altMin: "Alt. mín ▼",
        climb: "Desnivel +",
        descent: "Desnivel −",
        points: "Puntos",
        pois: "POIs",
        unpaved: "Sin asfaltar",

        // PointsPanel
        trackPoints: "Puntos del track",
        clickToStart: "Haz clic en el mapa para empezar a añadir puntos.",
        poi: "POI",

        // SearchBox
        searchPlace: "Buscar lugar…",

        // ShareDialog
        shareRoute: "Compartir ruta",
        shareDesc:
            "Cualquier persona con este enlace podrá ver tu ruta sin necesidad de cuenta.",
        copied: "Copiado",
        copy: "Copiar",
        shareTip: "Tip: la ruta viaja codificada en el enlace · sin servidor",

        // ElevationProfile
        elevationProfile: "Perfil de elevación",
        legendPaved: "Asfalto",
        legendUnpaved: "Pista",
        hideElevation: "Ocultar perfil de elevación",
        showElevationTitle: "Mostrar perfil de elevación",

        // TrackPlanner hints
        hintTrack:
            "Clic en el mapa para añadir punto · clic en la línea para insertar",
        hintPoi: "Clic en el mapa para añadir un POI",
        hintView: "Modo visualización (clics deshabilitados)",

        // TrackPlanner toasts
        toastSharedLoaded: "Ruta compartida cargada",
        toastCleared: "Track limpiado",
        toastNewRoute: "Nueva ruta creada",
        errAddBeforeElev: "Añade puntos antes de calcular altitudes",
        toastElevOk: "Altitudes obtenidas",
        errElevFail: "No se pudieron obtener altitudes",
        errElevError: "Error al obtener altitudes",
        errNeed2wp: "Necesitas al menos 2 waypoints",
        errNoRoute: "No se pudo trazar la ruta",
        routeTraced: "Ruta trazada ({n} puntos) por {mode}",
        modeTrails: "senderos",
        modeUnpaved: "pistas sin asfaltar",
        modeRoad: "carretera",
        modeCycle: "rutas ciclables",
        svcError: "Error de {svc}: {msg}",
        errNeed2surface: "Necesitas al menos 2 puntos para analizar la superficie",
        errSurfaceFail: "No se pudo analizar la superficie",
        surfaceAnalyzed: "Superficie analizada ({matched}/{total} puntos sobre vías)",
        errSurfaceError: "Error al analizar superficie: {msg}",
        imported: "Importados {p} puntos · {poi} POIs",
        errImport: "Error al importar: {msg}",
        errNothingExport: "Nada que exportar",
        exportedAs: "Exportado como {fmt}",
        errAddBeforeSave: "Añade puntos antes de guardar",
        savedToLibrary: "Ruta guardada en biblioteca",
        loaded: "Cargada: {name}",
        deletedFromLibrary: "Ruta eliminada de biblioteca",
        errAddBeforeShare: "Añade puntos antes de compartir",
        errTooLong:
            "Ruta demasiado larga para compartir por enlace. Exporta GPX.",
        centeredOn: "Centrado en: {name}",
        untitledRoute: "Ruta sin título",

        // MapView
        layerSat: "Satélite (Esri)",
        layerTopo: "Topográfico (OpenTopoMap)",
        layerCycle: "Ciclismo (CyclOSM)",
        layerDark: "Oscuro (Carto)",
        poiDefault: "Punto de interés",
        point: "Punto {n}",
        altitudeLabel: "Altitud: {n} m",
        remove: "Eliminar",
        name: "Nombre",
        notes: "Notas",
        removePoi: "Eliminar POI",

        // Document
        docTitle: "Vulkano · Planificador de Rutas",
    },
    en: {
        // Toolbar
        expandTools: "Expand tools",
        minimizeTools: "Minimize tools",
        trackNamePlaceholder: "Route name…",
        modeTrack: "Track",
        modePoi: "POI",
        modeView: "View",
        modeTrackTitle: "Add points to the track",
        modePoiTitle: "Add point of interest",
        modeViewTitle: "View only",
        undo: "Undo",
        undoTitle: "Undo last point",
        elevation: "Elevation",
        elevationTitle: "Get elevation (Open-Elevation)",
        surface: "Surface",
        surfaceTitle: "Analyze paved/unpaved surface (OSM)",
        autoTrace: "Auto-route",
        autoTraceTitle: "Route along roads or trails",
        offroad: "Offroad",
        offroadDesc: "Route along unpaved tracks and trails passable by vehicle",
        trackDifficulty: "Track difficulty",
        grade1: "Grade 1",
        grade1desc: "Gravel / car",
        grade2: "Grade 2",
        grade2desc: "Medium track",
        grade3: "Grade 3",
        grade3desc: "4x4 / hard",
        grade1hint: "Wide gravel tracks, suitable for cars",
        grade2hint: "Medium dirt tracks and trails",
        grade3hint: "Demanding terrain for 4x4 / off-road",
        brouterLabel: "Unpaved tracks (BRouter)",
        osrmLabel: "Snap to real roads (OSRM)",
        carMoto: "Car / motorbike",
        bike: "Bicycle",
        onFoot: "On foot",
        share: "Share",
        shareBtnTitle: "Generate a share link",
        importExport: "Import / Export",
        importLabel: "Import",
        importFile: "GPX / KML / GeoJSON file",
        exportLabel: "Export",
        library: "Library",
        savedRoutes: "Saved routes",
        noSavedRoutes: "No saved routes yet.",
        showOtherRoutes: "Show other routes",
        pts: "pts",
        save: "Save",
        newRoute: "New",
        newRouteTitle: "New empty route",
        clearTitle: "Clear all points",
        language: "Language",
        zoomIn: "Zoom in",
        zoomOut: "Zoom out",
        layers: "Layers",
        trackPointsToggle: "Track points",

        // StatsBar
        distance: "Distance →",
        roundtrip: "Round trip ⇄",
        altMax: "Max alt. ▲",
        altMin: "Min alt. ▼",
        climb: "Ascent +",
        descent: "Descent −",
        points: "Points",
        pois: "POIs",
        unpaved: "Unpaved",

        // PointsPanel
        trackPoints: "Track points",
        clickToStart: "Click on the map to start adding points.",
        poi: "POI",

        // SearchBox
        searchPlace: "Search place…",

        // ShareDialog
        shareRoute: "Share route",
        shareDesc:
            "Anyone with this link can view your route — no account needed.",
        copied: "Copied",
        copy: "Copy",
        shareTip: "Tip: the route is encoded in the link · no server",

        // ElevationProfile
        elevationProfile: "Elevation profile",
        legendPaved: "Paved",
        legendUnpaved: "Unpaved",
        hideElevation: "Hide elevation profile",
        showElevationTitle: "Show elevation profile",

        // TrackPlanner hints
        hintTrack: "Click the map to add a point · click the line to insert",
        hintPoi: "Click the map to add a POI",
        hintView: "View mode (clicks disabled)",

        // TrackPlanner toasts
        toastSharedLoaded: "Shared route loaded",
        toastCleared: "Track cleared",
        toastNewRoute: "New route created",
        errAddBeforeElev: "Add points before fetching elevation",
        toastElevOk: "Elevation fetched",
        errElevFail: "Could not fetch elevation",
        errElevError: "Error fetching elevation",
        errNeed2wp: "You need at least 2 waypoints",
        errNoRoute: "Could not trace the route",
        routeTraced: "Route traced ({n} points) via {mode}",
        modeTrails: "trails",
        modeUnpaved: "unpaved tracks",
        modeRoad: "road",
        modeCycle: "cycle routes",
        svcError: "{svc} error: {msg}",
        errNeed2surface: "You need at least 2 points to analyze the surface",
        errSurfaceFail: "Could not analyze the surface",
        surfaceAnalyzed: "Surface analyzed ({matched}/{total} points on ways)",
        errSurfaceError: "Error analyzing surface: {msg}",
        imported: "Imported {p} points · {poi} POIs",
        errImport: "Import error: {msg}",
        errNothingExport: "Nothing to export",
        exportedAs: "Exported as {fmt}",
        errAddBeforeSave: "Add points before saving",
        savedToLibrary: "Route saved to library",
        loaded: "Loaded: {name}",
        deletedFromLibrary: "Route deleted from library",
        errAddBeforeShare: "Add points before sharing",
        errTooLong: "Route too long to share by link. Export GPX instead.",
        centeredOn: "Centered on: {name}",
        untitledRoute: "Untitled route",

        // MapView
        layerSat: "Satellite (Esri)",
        layerTopo: "Topographic (OpenTopoMap)",
        layerCycle: "Cycling (CyclOSM)",
        layerDark: "Dark (Carto)",
        poiDefault: "Point of interest",
        point: "Point {n}",
        altitudeLabel: "Elevation: {n} m",
        remove: "Remove",
        name: "Name",
        notes: "Notes",
        removePoi: "Remove POI",

        // Document
        docTitle: "Vulkano · Route Planner",
    },
};

export function detectInitialLang() {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved === "es" || saved === "en") return saved;
    } catch (e) {
        /* ignore */
    }
    if (typeof navigator !== "undefined") {
        const langs =
            navigator.languages && navigator.languages.length
                ? navigator.languages
                : [navigator.language || "en"];
        const isSpanish = langs.some((l) =>
            (l || "").toLowerCase().startsWith("es"),
        );
        return isSpanish ? "es" : "en";
    }
    return "en";
}

let currentLang = detectInitialLang();

export function getLang() {
    return currentLang;
}

export function setLangGlobal(lang) {
    currentLang = lang === "es" ? "es" : "en";
    try {
        localStorage.setItem(STORAGE_KEY, currentLang);
    } catch (e) {
        /* ignore */
    }
    if (typeof document !== "undefined") {
        document.documentElement.lang = currentLang;
        document.title = translations[currentLang].docTitle;
    }
    return currentLang;
}

// Interpolates {var} placeholders. Usable outside React.
export function t(key, vars) {
    const lang = currentLang;
    let str =
        (translations[lang] && translations[lang][key]) ??
        translations.en[key] ??
        key;
    if (vars) {
        for (const k in vars) {
            str = str.replace(new RegExp("\\{" + k + "\\}", "g"), vars[k]);
        }
    }
    return str;
}
